import {APP_INITIALIZER, Injector, NgModule, Optional, SkipSelf} from '@angular/core';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {AuthGuard, NonAuthGuard, RolesGuard} from './guards';
import {HttpErrorInterceptor, HttpHeadersInterceptor} from './interceptors';
import {moduleSingletonGuard} from '@shared/functions';
import {LayoutModule} from '@core/modules/layout';
import {BootstrapLicenseFactory} from '@core/factories/bootstrap-license-factory';
import {BootstrapLicenseService} from '@core/services/bootstrap/bootstrap-license.service';
import {ServiceInjector} from '@core/services/service-injector.service';

@NgModule({
  declarations: [],
  imports: [
    LayoutModule
  ],
  exports: [],
  providers: [
    AuthGuard,
    NonAuthGuard,
    RolesGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpHeadersInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: BootstrapLicenseFactory,
      deps: [BootstrapLicenseService],
      multi: true,
    }
  ]
})
export class CoreModule {
  constructor(
    private injector: Injector,
    @Optional() @SkipSelf() core: CoreModule,
  ) {
    moduleSingletonGuard(core, 'CoreModule');
    this.setServiceInjector();
  }

  private setServiceInjector(): void {
    ServiceInjector.injector = this.injector;
  }
}
